<script setup>
import { computed } from 'vue';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  value: {
    type: Number,
    default: 0.5,
  },
  label: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const volumePercent = computed(() => Math.round(props.value * 100));

const volumeIcon = computed(() => {
  if (props.value === 0) return 'i-lucide-volume-x';
  if (props.value < 0.35) return 'i-lucide-volume';
  if (props.value < 0.7) return 'i-lucide-volume-1';
  return 'i-lucide-volume-2';
});

const onInput = event => {
  const val = Number(event.target.value) / 100;
  emit('change', Math.round(val * 100) / 100);
};
</script>

<template>
  <div>
    <label class="flex justify-between pb-1 text-heading-3 text-n-slate-12">
      {{ label }}
    </label>
    <div class="flex items-center gap-3 mt-2">
      <Icon :icon="volumeIcon" class="size-5 text-n-slate-11 flex-shrink-0" />
      <input
        type="range"
        min="0"
        max="100"
        step="5"
        :value="volumePercent"
        class="flex-grow h-2 rounded-lg appearance-none cursor-pointer accent-n-brand bg-n-alpha-3"
        @input="onInput"
      />
      <span class="text-sm text-n-slate-11 w-10 text-right flex-shrink-0">
        {{ volumePercent }}%
      </span>
    </div>
  </div>
</template>
